import { createSelector } from '@reduxjs/toolkit';
import { selectActiveReplyMessage } from './selectActiveReplyMessage';

export const selectActiveReplyMessageId = createSelector(
  [selectActiveReplyMessage],
  currentChatActiveReplyMessage => currentChatActiveReplyMessage?.messageId,
);
